// src/components/shops/postTemplates/Marquee.tsx
//
// Type only, set between two heavy rules. No photograph, by design.
//
// For the post that needs no elaboration — closed Monday, ten years today.
// Adding a picture to those would weaken them, so this template does not offer
// the option; the restraint is the whole effect.

import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, type TemplateProps } from './types'

export default function Marquee({
  title, body, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category)

  return (
    <div
      style={{
        background: '#f7efe1',
        borderRadius: px(3),
        padding: `${px(26)} ${px(20)} ${px(16)}`,
      }}
      data-shop={shopName}
    >
      <div style={{ borderTop: `${px(4)} solid #241810`, paddingTop: px(18) }}>
        {label && (
          <p
            style={{
              fontSize: px(9),
              letterSpacing: '0.36em',
              textTransform: 'uppercase',
              color: '#8c6a48',
              fontWeight: 700,
              textAlign: 'center',
              marginBottom: px(14),
            }}
          >
            {label}
          </p>
        )}
        <h3
          className="font-display"
          style={{
            fontSize: px(30),
            lineHeight: 1.06,
            letterSpacing: '-0.02em',
            color: '#120c08',
            fontWeight: 700,
            textAlign: 'center',
            margin: 0,
            textWrap: 'balance',
          }}
        >
          {title}
        </h3>
        {body && (
          <p
            style={{
              fontSize: px(13),
              lineHeight: 1.65,
              color: '#6e5038',
              textAlign: 'center',
              marginTop: px(12),
            }}
          >
            {body}
          </p>
        )}
      </div>

      <div style={{ borderTop: `${px(4)} solid #241810`, marginTop: px(20), paddingTop: px(12) }}>
        <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="light" scale={scale} />
      </div>
    </div>
  )
}
